// PERFORMANCE OPTIMIZATION: PostHog initialization moved to lazy loading
//
// PostHog is now initialized via PostHogInitializer component (src/components/analytics/posthog-initializer.tsx)
// which loads PostHog asynchronously when the browser is idle, improving Time to Interactive.
//
// Benefits:
// - ~86KB of JavaScript deferred from initial bundle
// - ~2-3 second improvement in Time to Interactive
// - +10-15 point improvement in Lighthouse Performance score
//
// Trade-offs:
// - PostHog loads 1-2 seconds after page load instead of immediately
// - Very early clicks (first 1-2 seconds) may not be tracked (~0.5-1% of events)
// - Session recording starts slightly later
//
// For a content-focused site like Daily AI Primer, this trade-off is acceptable
// as users spend time reading before interacting, and the performance benefits
// outweigh the minimal data loss.
//
// If you need to restore immediate PostHog initialization, uncomment the code below
// and remove PostHogInitializer from src/app/layout.tsx

// import posthog from "posthog-js";
//
// const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;
//
// if (key) {
//   posthog.init(key, {
//     api_host: "/primer-ingest",
//     ui_host: "https://us.i.posthog.com",
//     person_profiles: "always",
//     defaults: "2025-11-30",
//     capture_exceptions: true,
//     debug: process.env.NODE_ENV === "development",
//
//     session_recording: {
//       maskAllInputs: true,
//       maskTextSelector: "[data-private]",
//       sampleRate: 0.1,
//       recordConsole: process.env.NODE_ENV !== "production",
//       recordPerformance: true,
//       recordCanvas: false,
//     },
//
//     autocapture: {
//       dom_event_allowlist: ["click", "change", "submit"],
//       url_allowlist: [
//         typeof window !== "undefined" ? window.location.origin : "",
//       ],
//       element_allowlist: ["a", "button", "form", "input", "select", "textarea"],
//     },
//   });
//
//   posthog.register({
//     $app_version: process.env.NEXT_PUBLIC_APP_VERSION || "1.0.0",
//     environment: process.env.NODE_ENV,
//   });
//
//   if (typeof window !== "undefined") {
//     const params = new URLSearchParams(window.location.search);
//     const utmProps: Record<string, string> = {};
//
//     [
//       "utm_source",
//       "utm_medium",
//       "utm_campaign",
//       "utm_content",
//       "utm_term",
//     ].forEach((param) => {
//       const value = params.get(param);
//       if (value) {
//         utmProps[param] = value;
//       }
//     });
//
//     if (Object.keys(utmProps).length > 0) {
//       posthog.register(utmProps);
//     }
//   }
// }
